import type Good from './good';

export default interface GoodClass {
    name: string;
    id: number;
    classNumber: number;
    suggestions: Array<Good>;
    matches: Array<Good>;
}


export const GOOD_CLASSES = [
    {
        'name': 'Chemicals',
        'number': 1,
        'short_name': 'Chemicals'
    },
    {
        'name': 'Paint, varnishes, lacquer',
        'number': 2,
        'short_name': 'Paint'
    },
    {
        'name': 'Soap, perfume, cosmetics, cleaning products',
        'number': 3,
        'short_name': 'Cosmetics, cleaners'
    },
    {
        'name': 'Oils, grease, fuels',
        'number': 4,
        'short_name': 'Oil, fuel'
    },
    {
        'name': 'Pharmaceutical, medical and veterinary products',
        'number': 5,
        'short_name': 'Pharmaceuticals'
    },
    {
        'name': 'Metals, metal building materials',
        'number': 6,
        'short_name': 'Metal goods'
    },
    {
        'name': 'Tools, machines, motors, engines',
        'number': 7,
        'short_name': 'Machinery'
    },
    {
        'name': 'Hand tools, cutlery, razors',
        'number': 8,
        'short_name': 'Tools'
    },
    {
        'name': 'Computer hardware, software, electronics and electrical goods.',
        'number': 9,
        'short_name': 'Software, electronics'
    },
    {
        'name': 'Medical, surgical, dental and veterinary products.',
        'number': 10,
        'short_name': 'Medical devices'
    },
    {
        'name': 'Bathroom, plumbing lighting, heating, cooking equipment.',
        'number': 11,
        'short_name': 'Plumbing, lighting'
    },
    {
        'name': 'Vehicles (land, air, sea)',
        'number': 12,
        'short_name': 'Vehicles'
    },
    {           
        'name': 'Firearms, explosives, fireworks',
        'number': 13,
        'short_name': 'Explosives'
    },
    {
        'name': 'Jewellery, watches, clocks, precious stones and metals',
        'number': 14,
        'short_name': 'Jewellery, gems'
    },
    {
        'name': 'Musical instruments',
        'number': 15,
        'short_name': 'Musical instruments'
    },
    {
        'name': 'Paper, cardboard, stationery, packaging materials',
        'number': 16,
        'short_name': 'Paper, stationery'
    },
    {
        'name': 'Insulation, rubber and plastic materials',
        'number': 17,
        'short_name': 'Rubber, plastic'
    },
    {
        'name': 'Luggage, umbrellas, leather products',
        'number': 18,
        'short_name': 'Luggage'
    },
    {
        'name': 'Non-metal building materials',
        'number': 19,
        'short_name': 'Building materials'
    },
    {
        'name': 'Furniture, mirrors, picture frames',
        'number': 20,
        'short_name': 'Furniture'
    },
    {
        'name': 'Household containers and utensils, cleaning materials',
        'number': 21,
        'short_name': 'Homeware, glass'
    },
    {
        'name': 'Ropes, string, tents, sacks, sails',
        'number': 22,
        'short_name': 'Rope, tents'
    },
    {
        'name': 'Yarns, threads',
        'number': 23,
        'short_name': 'Yarn'
    },
    {   
        'name': 'Textiles, cloth, bed linen, table cloths',
        'number': 24,
        'short_name': 'Textiles'
    },
    {
        'name': 'Clothing, footwear, headgear',
        'number': 25,
        'short_name': 'Clothing'
    },
    {
        'name': 'Lace, embroidery, buttons, hooks',
        'number': 26,
        'short_name': 'Sewing supplies'
    },
    {
        'name': 'Carpets, rugs, flooring',
        'number': 27,
        'short_name': 'Flooring'
    },
    {
        'name': 'Toys, games and sports equipment',
        'number': 28,
        'short_name': 'Toys, sports goods'
    },
    {
        'name': 'Meat, fish, dairy products, eggs, compotes',
        'number': 29,
        'short_name': 'Meat, fish, dairy'
    },
    {
        'name': 'Coffee, tea, bread, pastries, sugar, sauces',
        'number': 30,
        'short_name': 'Coffee, bread, sugar'
    },
    {
        'name': 'Fruit, vegetables, plants, animals',
        'number': 31,
        'short_name': 'Fruit, vegetables'
    },
    {
        'name': 'Beer, non-alcoholic beverages',
        'number': 32,
        'short_name': 'Beer, beverages'
    },
    {
        'name': 'Wine, spirits, alcohol (excluding beer)',
        'number': 33,
        'short_name': 'Wine, spirits'
    },
    {
        'name': 'Cigarettes, cigars, tobacco, matches',
        'number': 34,
        'short_name': "Smokers' products"
    },
    {   
        'name': 'Business, advertising, retail, wholesale',
        'number': 35,
        'short_name': 'Business, retail'
    },
    {
        'name': 'Finance, insurance,  real estate',
        'number': 36,
        'short_name': 'Finance, real estate'
    },
    {
        'name': 'Building construction, repair, installation services',
        'number': 37,
        'short_name': 'Building, repair'
    },
    {
        'name': 'Telecommunications',
        'number': 38,
        'short_name': 'Communications'
    },
    {
        'name': 'Travel, transport, tourism, storage',
        'number': 39,
        'short_name': 'Travel, transport'
    },
    {
        'name': 'Treatment of materials',
        'number': 40,
        'short_name': 'Manufacturing'
    },
    {
        'name': 'Education, entertainment',
        'number': 41,
        'short_name': 'Education, entertainment'
    },
    {
        'name': 'Research and design',
        'number': 42,
        'short_name': 'Research, design'
    },
    {
        'name': 'Restaurants, bars, catering, accommodation',
        'number': 43,
        'short_name': 'Hotels, catering'
    },
    {
        'name': 'Medical, veterinary, beauty, agriculture and forestry',
        'number': 44,
        'short_name': 'Medical, beauty, forestry'
    },
    {
        'name': 'Social services, legal services, security',
        'number': 45,
        'short_name': 'Social, legal, security'
    }
]
